import { TextInput as RNTextInput } from 'react-native';

import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';
import type { TextInputSize } from '@opendoor/tokens-studio/dist/bricks-next/types/Components';
import { isWeb, styled } from '@tamagui/core';
import type { GetProps } from '@tamagui/core';

const { textInput: textInputTokens } = tokens;

/**
 * Styled text input shared by different kinds of input components
 */
export const TextInputField = styled(
  RNTextInput,
  {
    focusable: true,

    borderWidth: 0,
    outlineStyle: 'none',
    fontFamily: '$body',
    placeholderTextColor: textInputTokens.color.content.placeholderText.default,
    backgroundColor: '$transparent',

    // This is a workaround for a style set by primer.css
    // @ts-expect-error - RNTextInput does not have a boxShadow prop
    boxShadow: isWeb ? 'none' : undefined,

    variants: {
      size: (size: TextInputSize) => ({
        fontSize: textInputTokens.typography.valueText[size],
        fontWeight: textInputTokens.typography.valueText[size],
        letterSpacing: textInputTokens.typography.valueText[size],
      }),
    } as const,
  },
  { isInput: true, accept: { placeholderTextColor: 'color' } as const },
);

export type TextInputFieldProps = GetProps<typeof TextInputField>;
